import React from "react";
import { useApp } from "../context/AppContext";

// Official Ssuq icon mark (transparent PNG)
export const LogoMark = ({ size = 40 }) => (
  <img src="/ssuq-icon.png" alt="Ssuq" style={{ height: size, width: "auto" }} className="object-contain" />
);

// Full official logo lockup (icon + wordmark), transparent
export const FullLogo = ({ className = "" }) => (
  <img src="/ssuq-logo-t.png" alt="Ssuq" className={`object-contain ${className}`} />
);

const Logo = ({ light = false }) => {
  const { lang } = useApp();
  return (
    <div className="flex items-center gap-2 select-none">
      <img src="/ssuq-icon.png" alt="Ssuq" className="h-10 w-auto object-contain" />
      {lang === "ar" ? (
        <span className="font-display text-3xl font-extrabold tracking-tight leading-none" dir="rtl">
          <span className={light ? "text-white" : "text-navy"}>سو</span>
          <span className="text-orange">ق</span>
        </span>
      ) : (
        <span className="font-display text-2xl font-extrabold tracking-tight leading-none">
          <span className={light ? "text-white" : "text-navy"}>S</span>
          <span className="text-orange">suq</span>
        </span>
      )}
    </div>
  );
};

export default Logo;
